import cx from 'classnames';
import styles from './JackpotIcon.module.scss';

import {
  Iron,
  Iron1,
  Iron2,
  Iron3,
  Bronze,
  Bronze1,
  Bronze2,
  Bronze3,
  Silver,
  Silver1,
  Silver2,
  Silver3,
  IronSmall,
  BronzeSmall,
  SilverSmall,
  Final1,
  Final1Icon,
} from '@assets/icons';
import { FC, useRef } from 'react';
import { JackpotSlug } from '@entities/jackpot';
import { useAppDispatch } from '@app/store';
import { setTooltipParams } from '@pages/JackpotPage/store/jackpotSlice';

interface JackpotIconProps {
  size?: number;
  className?: string;
  smallIcon?: boolean;
  drawAmount?: string;
  showTooltip?: boolean;
  bigFinalIcon?: boolean;
  leftDirection?: boolean;
  jackpotSlug: JackpotSlug;
  dataTutorialAttr?: string;
}

export const JackpotIcon: FC<JackpotIconProps> = ({
  size = 12,
  className,
  jackpotSlug,
  drawAmount = '',
  smallIcon = false,
  showTooltip = true,
  bigFinalIcon = false,
  leftDirection = false,
  dataTutorialAttr,
}) => {
  const dispatch = useAppDispatch();
  const ref = useRef<HTMLDivElement>(null);

  const getJackpotIcon = () => {
    switch (jackpotSlug) {
      case 'OpenQual-A':
        if (smallIcon) return <IronSmall width={size} height={size} />;
        return <Iron width={size} height={size} />;
      case 'ClosedQual-A1':
        return <Iron1 width={size} height={size} />;
      case 'ClosedQual-A2':
        return <Iron2 width={size} height={size} />;
      case 'ClosedQual-A3':
        return <Iron3 width={size} height={size} />;
      case 'OpenQual-B':
        if (smallIcon) return <BronzeSmall width={size} height={size} />;
        return <Bronze width={size} height={size} />;
      case 'ClosedQual-B1':
        return <Bronze1 width={size} height={size} />;
      case 'ClosedQual-B2':
        return <Bronze2 width={size} height={size} />;
      case 'ClosedQual-B3':
        return <Bronze3 width={size} height={size} />;
      case 'OpenQual-C':
        if (smallIcon) return <SilverSmall width={size} height={size} />;
        return <Silver />;
      case 'ClosedQual-C1':
        return <Silver1 width={size} height={size} />;
      case 'ClosedQual-C2':
        return <Silver2 width={size} height={size} />;
      case 'ClosedQual-C3':
        return <Silver3 width={size} height={size} />;
      case 'Final1':
        if (bigFinalIcon) return <Final1Icon width={size} height={size} />;
        return <Final1 width={size} height={size} />;
      default:
        return null;
    }
  };

  return (
    <div
      ref={ref}
      data-tutorial={dataTutorialAttr}
      className={cx(className, styles.jackpotIconContainer)}
      onClick={() => {
        const pos = ref.current?.getBoundingClientRect();

        if (pos && showTooltip) {
          dispatch(
            setTooltipParams({
              drawAmount,
              jackpotSlug,
              leftDirection: leftDirection,
              position: { top: pos.top, left: pos.left },
            }),
          );
        }
      }}
    >
      {getJackpotIcon()}
    </div>
  );
};
